import React, { useEffect, useRef } from "react";

export default function AutoLogout({ onLogout }) {
    const timerRef = useRef(null);

    // Reset timer when user interacts
    const resetTimer = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        // Restart 5 minutes timer (300000ms)
        timerRef.current = setTimeout(() => {
            onLogout?.(); // Call logout function
        }, 300000);
    };

    useEffect(() => {
        // Run first time
        resetTimer();

        // Listen to user interactions
        const events = ["mousemove", "keydown", "click", "scroll"];
        events.forEach((event) => window.addEventListener(event, resetTimer));

        return () => {
            // Cleanup
            if (timerRef.current) clearTimeout(timerRef.current);
            events.forEach((event) => window.removeEventListener(event, resetTimer));
        };
    }, []);

    return null; // Nothing is displayed
}
